<template>
  <div>
    <div class="my-1">
      <b-button
        variant="primary"
        class="mr-1"
        @click="fileInputClick"
      >
        {{ $t('objects.select_floor_plans') }}
      </b-button>
      <b-form-file
        ref="filePlanning"
        v-model="new_planning_file"
        plain
        class="d-none"
        :browse-text="$t('objects.select_floor_plans')"
        @input="fileChanged"
      />
    </div>
    <b-table
      striped
      :fields="fields"
      :items="GET_STAGE_PLANNINGS"
    >
      <template #head()="data">
        <span>{{ $t(data.label) }}</span>
      </template>
      <template
        #cell(image_2d)="props"
      >
        <div style="max-width: 150px">
          <b-img
            class="w-100"
            thumbnail
            :src="props.item.image_2d"
          />
        </div>
      </template>
      <template
        #cell(image_3d)="props"
      >
        <div
          v-if="props.item.image_3d"
          style="max-width: 150px"
        >
          <b-img
            class="w-100"
            thumbnail
            :src="props.item.image_3d"
          />
        </div>
        <div v-else>
          <b-button
            variant="primary"
            @click="upload3dImage(props.item.id)"
          >
            {{ $t('objects.upload') }}
          </b-button>
        </div>
      </template>
      <template #cell(stages)="props">
        <span
          v-for="(stage, index) in props.item.stages"
          :key="index"
        >
          {{ stage }},
        </span>
        <div class="mt-50">
          <b-button
            v-b-modal.stage-planning-attachments
            variant="primary"
            size="sm"
            @click="openEditModal(props.item)"
          >
            {{ $t('objects.mark_floors') }}
          </b-button>
        </div>
      </template>
      <template #cell(actions)="props">
        <b-button
          v-b-modal.stage-planning
          variant="warning"
          size="sm"
          @click="openEditModal(props.item)"
        >
          <feather-icon
            icon="EditIcon"
          />
          {{ $t('generals.edit') }}
        </b-button>
        <b-button
          variant="danger"
          size="sm"
          @click="deletePlanning(props.item.id)"
        >
          <feather-icon
            icon="TrashIcon"
          />
          {{ $t('generals.delete') }}
        </b-button>
      </template>
      <template #empty>
        <div class="text-center">{{ $t('general.no_records_to_show') }}</div>
      </template>
    </b-table>
    <b-modal
      id="stage-planning"
      :title="$t('objects.layout')"
      size="xl"
      :ok-title="$t('generals.save')"
      no-close-on-backdrop
      :cancel-title="$t('generals.cancel')"
      @ok="saveChanges"
    >
      <b-row>
        <b-form-file
          ref="editfilePlanning"
          v-model="edited_planning_file"
          plain
          class="d-none"
          :browse-text="$t('objects.choose_room_layouts')"
          @input="editedfileChange"
        />
        <b-col
          v-if="stage_planning.image_2d"
          class="d-flex flex-column align-items-center"
          cols="6"
        >
          <b-img
            height="450px"
            :src="stage_planning.image_2d_preview || stage_planning.image_2d"
          />
          <div class="mt-2 d-flex justify-content-center">
            <b-button
              pill
              variant="warning"
              size="sm"
              class="mr-3"
              @click="editPlanning('2D')"
            >
              <feather-icon
                icon="EditIcon"
              />
              {{ $t('generals.update') }}
            </b-button>
            <b-button
              variant="danger"
              pill
              size="sm"
              @click="stage_planning.image_2d = null"
            >
              <feather-icon
                icon="TrashIcon"
              />
              {{ $t('generals.delete') }}
            </b-button>
          </div>
        </b-col>
        <b-col
          v-if="stage_planning.image_3d"
          class="d-flex flex-column align-items-center"
          cols="6"
        >
          <b-img
            height="450px"
            :src="stage_planning.image_3d_preview || stage_planning.image_3d"
          />
          <div class="mt-2 d-flex justify-content-center">
            <b-button
              pill
              variant="warning"
              size="sm"
              class="mr-3"
              @click="editPlanning('3D')"
            >
              <feather-icon
                icon="EditIcon"
              />
              {{ $t('generals.update') }}
            </b-button>
            <b-button
              variant="danger"
              pill
              size="sm"
              @click="stage_planning.image_3d = null"
            >
              <feather-icon
                icon="TrashIcon"
              />
              {{ $t('generals.delete') }}
            </b-button>
          </div>
        </b-col>
      </b-row>
      <custom-input
        v-model="stage_planning.planning_code"
        class="mt-2"
        :field-label="$t('objects.layout_code')"
      />
      <custom-input
        v-model="stage_planning.stages"
        class="mt-2"
        component-name="v-select"
        :field-label="$t('objects.floors')"
        :field-props="{
          multiple: true,
          options: GET_STAGES.stages,
        }"
      />

    </b-modal>
    <b-modal
      id="stage-planning-attachments"
      :title="$t('objects.layout')"
      size="xl"
      :ok-title="$t('generals.save')"
      no-close-on-backdrop
      :cancel-title="$t('generals.cancel')"
      @ok="saveChanges"
    >
      <custom-input
        v-model="stage_planning.planning_code"
        class="mt-2"
        :field-label="$t('objects.layout_code')"
      />
      <custom-input
        v-model="stage_planning.stages"
        class="mt-2"
        component-name="v-select"
        :field-label="$t('objects.floors')"
        :field-props="{
          multiple: true,
          options: GET_STAGES.stages,
        }"
      />

    </b-modal>
  </div>
</template>

<script>
import {
  BButton, BTable, BFormFile, BImg, BRow, BCol,
} from 'bootstrap-vue'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'
import customInput from '@/components/CustomValidatedInput.vue'
import formatters from '@/mixins/extra'

export default {
  components: {
    BButton,
    BTable,
    BFormFile,
    BImg,
    FeatherIcon,
    BRow,
    BCol,
    customInput,
  },
  mixins: [formatters],
  data() {
    return {
      new_planning_file: null,
      edited_planning_file: null,
      edited_planning_type: null,
      stage_planning: {},
      is_3d_image: false,
      editing_planning_id: null,
      fields: [
        {
          key: 'image_2d',
          label: 'objects.layout',
        },
        {
          key: 'image_3d',
          label: 'objects.3d_planning',
        },
        {
          key: 'planning_code',
          label: 'objects.name',
        },
        {
          key: 'stages',
          label: 'objects.floors_corresponding_layout',
        },
        {
          key: 'actions',
          label: 'generals.actions',
          tdClass: 'width-350 d-flex justify-content-around',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('apartments', ['GET_ONE_APARTMENT', 'GET_APARTMENT_MAIN_INFO']),
    ...mapGetters('stages', ['GET_STAGE_PLANNINGS', 'GET_STAGES']),
    getFields() {
      return [
        {
          component_name: 'v-select',
          obj_name: 'stages',
          label: this.$t('objects.indicate_the_floors_corresponding_layout'),
          props: {
            options: this.GET_STAGES,
            label: 'floor',
            multiple: true,
            reduce: option => option.id,
          },
        },
        {
          label: this.$t('objects.name'),
          obj_name: 'title',
        },
      ]
    },
  },
  mounted() {
    this.FETCH_STAGE_PLANNINGS({ apartment: this.$route.params.id, page_size: 100000 })
    this.FETCH_STAGES_BY_APARTMENT(this.$route.params.id)
    this.FETCH_ONE_APARTMENT(this.$route.params.id).then(() => {
      this.updateBreadcrumb()
    })
  },
  methods: {
    ...mapActions('apartments', ['FETCH_ONE_APARTMENT']),
    ...mapActions('stages', ['CREATE_STAGE_PLANNING', 'DELETE_STAGE_PLANNING', 'FETCH_STAGE_PLANNINGS', 'EDIT_STAGE_PLANNING', 'DELETE_STAGE_PLANNING',
      'FETCH_STAGES_BY_APARTMENT', 'EDIT_STAGE_PLANNING_STAGES']),
    ...mapMutations('breadcrumb', ['UPDATE_BREADCRUMB']),
    fileInputClick() {
      this.$refs.filePlanning.$el.click()
    },
    updateBreadcrumb() {
      const [first, second, third, fourth] = this.$_removeObjectConnection(this.$route.meta.breadcrumb)
      second.text = this.GET_APARTMENT_MAIN_INFO.rc_object
      second.to = second.to.replace(':id', this.GET_ONE_APARTMENT.rc_object)
      third.text = this.GET_ONE_APARTMENT.title
      third.to = third.to.replace(':id', this.GET_ONE_APARTMENT.id)
      this.UPDATE_BREADCRUMB([first, second, third, fourth])
    },
    fileChanged() {
      if (this.new_planning_file) {
        const fd = new FormData()
        fd.append('apartment', this.$route.params.id)
        if (this.is_3d_image) {
          fd.append('image_3d', this.new_planning_file)
          fd.append('id', this.editing_planning_id)
          this.EDIT_STAGE_PLANNING(fd).then(() => {
            this.is_3d_image = false
            this.$_successToast(this.$t('generals.updated'))
            this.FETCH_STAGE_PLANNINGS({ apartment: this.$route.params.id, pageSize: 100000 })
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        } else {
          fd.append('image_2d', this.new_planning_file)
          fd.append('planning_code', this.new_planning_file.name)
          this.CREATE_STAGE_PLANNING(fd).then(() => {
            this.$_successToast(this.$t('generals.added'))
            this.FETCH_STAGE_PLANNINGS({ apartment: this.$route.params.id, pageSize: 100000 })
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      }
    },
    saveChanges() {
      const {
        id, image_2d, image_3d, planning_code, stages,
      } = this.stage_planning
      const reqData = new FormData()
      reqData.append('id', id)
      reqData.append('planning_code', planning_code)
      if (typeof image_2d !== 'string') reqData.append('image_2d', image_2d)
      if (typeof image_3d !== 'string') reqData.append('image_3d', image_3d)
      this.EDIT_STAGE_PLANNING(reqData).then(() => {
        this.$_successToast(this.$t('generals.updated'))
        this.FETCH_STAGE_PLANNINGS({ apartment: this.$route.params.id, pageSize: 100000 })
      }).catch(() => {
        this.$_errorToast('Ошибка')
      })
      this.EDIT_STAGE_PLANNING_STAGES({ id, stages, apartment: this.$route.params.id }).then(() => {
        this.stage_planning = {}
        this.$_successToast(this.$t('generals.attached'))
        this.FETCH_STAGE_PLANNINGS({ apartment: this.$route.params.id, pageSize: 100000 })
      }).catch(() => {
        this.$_errorToast(this.$t('generals.error'))
      })
    },
    upload3dImage(id) {
      this.is_3d_image = true
      this.editing_planning_id = id
      this.fileInputClick()
    },
    openEditModal(stage_planning) {
      this.stage_planning = this.$_removeObjectConnection(stage_planning)
    },
    editPlanning(type) {
      console.log('jnj')
      this.edited_planning_type = type
      this.$refs.editfilePlanning.$el.click()
    },
    async editedfileChange() {
      if (this.edited_planning_type === '2D') {
        console.log('2d')
        this.stage_planning.image_2d_preview = await this.$_convertToBase64(this.edited_planning_file)
        this.stage_planning.image_2d = this.edited_planning_file
      } else if (this.edited_planning_type === '3D') {
        this.stage_planning.image_3d_preview = await this.$_convertToBase64(this.edited_planning_file)
        this.stage_planning.image_3d = this.edited_planning_file
      }
    },
    deletePlanning(id) {
      this.$_showAreYouSureModal().then(value => {
        if (value) {
          this.DELETE_STAGE_PLANNING(id).then(() => {
            this.$_successToast(this.$t('generals.deleted'))
            this.FETCH_STAGE_PLANNINGS({ apartment: this.$route.params.id, pageSize: 100000 })
          }).catch(() => {
            this.$_errorToast(this.$t('generals.error'))
          })
        }
      })
    },
    addSelections(elements) {
      console.log(elements)
    },
  },
}
</script>

<style>

</style>
